import { type CSSProperties, type ReactElement } from "react";
import { Card } from "antd";
import { useDarkMode } from "@/context";

const { Meta } = Card;

interface SkillCardProps {
  title: string;
  icon: ReactElement;
  width: number;
  height: number;
  fontWeight: CSSProperties["fontWeight"];
}

export const SkillCard = ({ title, icon, width, height, fontWeight }: SkillCardProps): ReactElement => {
  const { modeClass } = useDarkMode();

  return (
    <Card
      style={{ width, height, fontWeight }}
      cover={icon}
      className={`skillCard ${modeClass}`}
      bordered={false}
    >
      <Meta title={title} />
    </Card>
  );
};
